import React from 'react';
import ReactDOM from 'react-dom/client';
import "../src/style/css/iconsax.css";
import ALLRoutes from './feature-module/router/router';
import { BrowserRouter } from 'react-router-dom';
import { base_path } from './environment';
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import './index.scss';
import { Provider } from 'react-redux';
import store from './core/redux/store';
import "../node_modules/@tabler/icons-webfont/dist/tabler-icons.css";
import "../node_modules/@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "../node_modules/@fortawesome/fontawesome-free/css/all.min.css";
import { Modal } from "bootstrap"; // 👈 importa a classe Modal
import { AuthProvider } from './feature-module/auth/AuthProvider';
import { PacoteProvider } from './core/common/PacoteContext/PacoteContext';
import "leaflet/dist/leaflet.css";

import { QrCodeModalProvider } from './feature-module/userDashboard/myBooking/QrCodeModalContext';
import AppInitializer from './core/AppInitializer'; // 👈 importa o listener global

// 👇 expõe no escopo global
(window as any).bootstrap = { Modal };

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AuthProvider>
        <PacoteProvider>
          <QrCodeModalProvider>
            <BrowserRouter basename={base_path}>
              <ALLRoutes />
              <AppInitializer /> 
            </BrowserRouter>
          </QrCodeModalProvider>
        </PacoteProvider>
      </AuthProvider>
    </Provider>
  </React.StrictMode>
);